import { MIME_TYPES_TO_EXTENSION } from '@/utils/constants'

export function getFileExtension(mimeType: string): string {
  return MIME_TYPES_TO_EXTENSION?.[mimeType] || ''
}

export function trimFileExtension(filename: string): string {
  return filename.split('.').slice(0, -1).join('.')
}

export function getMimeTypeByExtension(extension: string): string {
  const headers = Object.entries(MIME_TYPES_TO_EXTENSION)
  const header = headers.find((header) => header[1].toLowerCase() === extension)

  return header ? header[0] : ''
}

export function simulateFileDownload(
  data: Blob,
  filename: string,
  mime?: string,
  bom?: string | Uint8Array
): void {
  // const blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
  // const blob = new Blob(blobData, {
  //   type: mime || 'application/octet-stream'
  // })

  const blob = data

  const blobUrl = (window.URL && window.URL.createObjectURL)
    ? window.URL.createObjectURL(blob)
    : window.webkitURL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.style.display = 'none'
  tempLink.href = blobUrl
  tempLink.setAttribute('download', filename)

  // Safari thinks _blank anchor are pop-ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank')
  }

  document.body.appendChild(tempLink)
  tempLink.click()

  // Fixes "webkit blob resource error 1"
  setTimeout(() => {
    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobUrl)
  }, 200)
}
